module.exports = __webpack_public_path__ + "media/Components/fonts/GreatVibes-e45e6e2ddb17d288adcbca370ea68500.ttf";